// extracted by mini-css-extract-plugin
export default {"arrow":"backArrowButton_arrow__jb6ta"};